<template>
  <v-card min-height="400">
    <vue-card-title
      :title="'Client Branch'"
      :subtitle="
        'Refer to the following information on client\'s branch information'
      "
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="(clientBranchForm = true) && (selectedBranchData = {})"
        >
          Create Branch
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col md="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else class="fill-height">
        <v-col md="12">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" md="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" md="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-col
          v-for="(branch, index) in fetchedData"
          :key="index"
          class="text-center"
          md="4"
        >
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 9 : 2}`"
              class="pointer border"
              height="100%"
            >
              <v-img
                src="@/static/images/crm/address.png"
                aspect-ratio="5"
              ></v-img>
              <v-card-text>
                <a class="title mb-0 blue--text link text-truncate">{{
                  branch.address
                }}</a>
                <div>
                  <a
                    class="font-0 grey--text cursor-pointer"
                    @click="
                      (selectedClientBranchData = branch) &&
                        (clientBranchForm = true)
                    "
                    >Update</a
                  >
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col md="12" class="hover-grey">
                    <display-data
                      :display-value="branch.email"
                      display-title="Email"
                    ></display-data>
                  </v-col>
                  <v-col md="12" class="hover-grey">
                    <display-data
                      :display-value="branch.head_office ? `Yes` : `No`"
                      display-title="Head Office"
                    ></display-data>
                  </v-col>
                  <v-col md="12">
                    <v-divider class="my-2"></v-divider>
                    <div class="d-flex">
                      <h4 class="text-left">
                        Contact Numbers
                      </h4>
                      <div class="text-right">
                        <a
                          class="link blue--text font-weight-bold"
                          @click="
                            (clientBranchContactNumberForm = true) &&
                              (selectedClientBranchData = branch)
                          "
                        >
                          <v-icon
                            v-text="$getIcon('mdiPlus')"
                            size="20"
                          ></v-icon>
                        </a>
                      </div>
                    </div>
                    <v-divider class="my-1"></v-divider>
                  </v-col>
                  <v-col v-if="branch.phone_numbers.length === 0" md="12">
                    No contact numbers found...
                  </v-col>
                  <v-col
                    v-for="(number, index) in branch.phone_numbers"
                    v-else
                    :key="index"
                    md="12"
                    class="hover-grey"
                  >
                    <display-data
                      :display-data="number"
                      :display-title="number.number_type"
                      :display-value="number.number"
                      :edit-form.sync="clientBranchContactNumberForm"
                      :edit-data.sync="selectedClientBranchContactNumberData"
                      editable
                    ></display-data>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-card-text>
    <div>
      <!-- Client Branch Form -->
      <v-bottom-sheet v-model="clientBranchForm" scrollable persistent>
        <v-card tile>
          <vue-card-title
            :display-card.sync="clientBranchForm"
            :title="cardTitle"
            :subtitle="'Fill up the following form to action on client branch.'"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="clientBranchForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <client-branch-form
              v-if="selectedClientBranchData && clientBranchForm"
              :action-data="selectedClientBranchData"
              @clientBranchFormResponse="formSuccess"
              :client-slug="clientDetail.slug"
            >
            </client-branch-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / client branch Form -->
    </div>
    <div>
      <!-- Client Branch Contact Number Form -->
      <v-bottom-sheet
        v-model="clientBranchContactNumberForm"
        scrollable
        persistent
      >
        <v-card tile>
          <vue-card-title
            :display-card.sync="clientBranchContactNumberForm"
            :title="cardTitle"
            :icon="$getIcon('mdiFileDocumentEdit')"
            :subtitle="
              'Fill up the following form to action on client branch contact number.'
            "
            closable
            @close="clientBranchContactNumberForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <client-branch-contact-number-form
              v-if="
                selectedClientBranchContactNumberData &&
                  clientBranchContactNumberForm
              "
              :action-data="selectedClientBranchContactNumberData"
              :client-branch-data="selectedClientBranchData"
              @clientBranchPhoneNumberFormResponse="formSuccess"
            >
            </client-branch-contact-number-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Client Branch Contact Number Form -->
    </div>
  </v-card>
</template>
<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import DisplayData from "@/components/crm/layout_utils/DisplayData";
import ClientBranchForm from "@/components/crm/client/forms/ClientBranchForm";
import ClientBranchContactNumberForm from "@/components/crm/client/forms/ClientBranchContactNumberForm";

export default {
  components: {
    DisplayData,
    ClientBranchForm,
    ClientBranchContactNumberForm
  },
  mixins: [PaginationMixin],
  props: {
    clientDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // paginationMixin
      fetchAPI:
        "/api/v1/crm/client-branch/" +
        "?client__slug=" +
        this.clientDetail.slug,
      searchLabel: "Search for branch",
      // form
      cardTitle: "",
      clientBranchForm: false,
      selectedClientBranchData: {},
      // form client branch contact number
      clientBranchContactNumberForm: false,
      selectedClientBranchContactNumberData: {}
    };
  },
  watch: {
    clientBranchForm(newVal) {
      if (Object.keys(this.selectedClientBranchData).length > 0 && newVal) {
        this.cardTitle = "Update Branch";
      } else {
        this.selectedClientBranchData = {};
        this.cardTitle = "Create Branch";
      }
    },
    clientBranchContactNumberForm(newVal) {
      if (
        Object.keys(this.selectedClientBranchContactNumberData).length > 0 &&
        newVal
      ) {
        this.cardTitle = "Update Branch Contact Number";
      } else {
        this.selectedClientBranchContactNumberData = {};
        this.cardTitle = "Create Branch Contact Number";
      }
    },
    clientDetail: {
      handler(newVal) {
        this.clientDetail = newVal;
        this.fetchData();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formSuccess() {
      this.clientBranchForm = false;
      this.clientBranchContactNumberForm = false;
      this.fetchData();
    }
  }
};
</script>
